import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { FulfillService } from '../../fulfill.service';
import { PanelState } from '../../utils/models';
import { takeUntil, map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ShippingManifestsListComponent } from '../fulfill-shipping-manifests/shipping-manifests-list/shipping-manifests-list.component';
import { PdqUser } from '@pdqdev/pdq-shared/dist/entities';
import { UserManagementService } from '@app/services/user-management/user-management.service';
import { OrderBatchService } from '@app/services/order-batch/order-batch.service';
@Component({
  selector: 'fulfill-batch-list',
  templateUrl: './fulfill-batch-list.component.html',
  styleUrls: ['./fulfill-batch-list.component.scss'],
  standalone: false,
})
export class FulfillBatchListComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject();
  showHistory;
  batches = {
    deliveryReady: [],
    fulfillmentReady: [],
  };

  activeTab;
  labels: {
    all: string;
    fulfillmentReady: string;
    deliveryReady: string;
  } = {
    all: '',
    fulfillmentReady: '',
    deliveryReady: '',
  };
  pdqUsersList: PdqUser[];
  columns = ['', 'Batch details', 'Pickup', 'Fulfillment status', 'Owner', 'Label status', ''];

  constructor(
    private fulfillService: FulfillService,
    private orderBatchService: OrderBatchService,
    private dialog: MatDialog,
    private umService: UserManagementService,
  ) {}

  ngOnInit(): void {
    this.fulfillService.onSetBatches
      .pipe(
        takeUntil(this.destroy$),
        map((batches) => {
          return this.orderBatchService.getBatchesByState(batches, this.fulfillService.shopMetadata);
        }),
      )
      .subscribe((batches) => {
        this.batches = batches;
        this.setLabels();
      });

    this.umService.users$.pipe(takeUntil(this.destroy$)).subscribe((users) => {
      this.pdqUsersList = users;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  setLabels() {
    this.labels.all = `All (${this.batches.fulfillmentReady.length + this.batches.deliveryReady.length})`;
    this.labels.fulfillmentReady = `Fulfillment ready (${this.batches.fulfillmentReady.length})`;
    this.labels.deliveryReady = `Delivery ready (${this.batches.deliveryReady.length})`;
  }

  scanLabel() {
    this.fulfillService.togglePanel(true);
    this.fulfillService.setPanelState(PanelState.SCAN);
  }

  setActiveTab(event) {
    this.activeTab = event;
  }

  shippingManifests() {
    this.dialog.open(ShippingManifestsListComponent, {
      width: '974px',
      height: '855px',
      minHeight: '500px',
      maxWidth: '90vw',
      maxHeight: 'calc(100vh - 3.75rem)',
      panelClass: 'overflow-visible-class',
      disableClose: true,
      data: {
        shopMetadata: this.fulfillService.shopMetadata,
        batches: this.batches.fulfillmentReady.concat(this.batches.deliveryReady),
      },
    });
  }
}
